// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2069":"64b0b10f2de3d6b35d1d","2968":"ef7b5837476f72ca1f39","3393":"63c9c65778c92668403d","3589":"f817f2b035323db57acf","4127":"4d037bff65976ede8bc1","4578":"f608b8beb5555a613f89","6532":"a148c5d533e65dcb0fbc"}[chunkId] + ".bundle.js";
};